import {membership} from "../lib/Membership.ts";

import {useCallback, useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import AuthContext from "../components/AuthContext.ts";
import {frontBaseUrl, frontEndType} from "../build_constants.ts";
import {FRONT_END_TYPE} from "../constants.ts";
import {useTranslation} from "react-i18next";

interface ContentProps {
    redirectPage: string;
}

export default function Logout({redirectPage}: ContentProps) {
    const {i18n} = useTranslation();
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    const logout = useCallback(async () => {
        if (!authContext) {
            throw new Error("authContext is null");
        }

        await membership.logout();
        await authContext.invalidate();

        if ((frontBaseUrl !== "/" && frontBaseUrl !== "") && frontEndType == FRONT_END_TYPE.XSLAB) {
            if(i18n.language == "ko") {
                window.location.href = "/";
                return;
            }
            window.location.href = `/${i18n.language}`;
            return;
        }

        const navigateState = {from: {pathname: location.pathname, search: location.search, hash: location.hash}};
        navigate(redirectPage, {replace: true, state: navigateState});

    }, [authContext, redirectPage, navigate]);

    useEffect(() => {
        logout().finally();
    });

    return <></>;
}